import { render, staticRenderFns } from "./ExamStoreCustomerDetail.vue?vue&type=template&id=1bab3b3b&scoped=true&"
import script from "./ExamStoreCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./ExamStoreCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamStoreCustomerDetail.vue?vue&type=style&index=0&id=1bab3b3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab3b3b",
  null
  
)

export default component.exports